import { render, staticRenderFns } from "./balance_price_detail.vue?vue&type=template&id=2a8e7190&"
import script from "./balance_price_detail.vue?vue&type=script&lang=js&"
export * from "./balance_price_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/yong9/vege_v2/vege_v2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VDataTable,VProgressLinear,VSnackbar,VSpacer,VToolbar,VToolbarTitle})
